<template>
      <div class="main">
        <alert></alert>
        <router-view></router-view>
      </div>
</template>

<script>
import alert from '../components/alert.vue'


export default {
  name: 'compact',
  data () {
    return {
    }
  },
  methods: {},
  components: {
    alert,
  }
}
</script>

<style scoped>

  .main {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

</style>